export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholderError@3x.png";